import { useCallback, useState } from 'react';

const useFetch = (requestFn) => {
  const [res, setRes] = useState({
    result: null,
    errorResult: null,
    success: false,
    error: false,
    isLoading: false,
  });

  const doFetch = useCallback(async () => {
    setRes((prevState) => ({ ...prevState, isLoading: true }));
    try {
      const result = await requestFn();
      return setRes({
        result,
        errorResult: null,
        success: true,
        isLoading: false,
        error: false,
      });
    } catch (e) {
      return setRes({
        result: null,
        errorResult: e,
        success: false,
        isLoading: false,
        error: true,
      });
    }
  }, [requestFn]);

  return [res, doFetch];
};

export default useFetch;
